import _app from "../../../views/_app.tsx";

/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { viewManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
const manifest = {
  "404": dynamic(() => import("../../../views/404.tsx"), "views/404.tsx"),
  "_app": _app,
  "page": dynamic(() => import("../../../views/page.tsx"), "views/page.tsx"),
  "single": dynamic(() => import("../../../views/single.tsx"), "views/single.tsx"),
  "single-article": dynamic(() => import("../../../views/single-article.tsx"), "views/single-article.tsx"),
  "single-authors": dynamic(() => import("../../../views/single-authors.tsx"), "views/single-authors.tsx"),
  "single-case-study": dynamic(() => import("../../../views/single-case-study.tsx"), "views/single-case-study.tsx"),
  "single-podcast": dynamic(() => import("../../../views/single-podcast.tsx"), "views/single-podcast.tsx"),
  "single-seo-landing": dynamic(() => import("../../../views/single-seo-landing.tsx"), "views/single-seo-landing.tsx"),
  "single-whitepaper": dynamic(() => import("../../../views/single-whitepaper.tsx"), "views/single-whitepaper.tsx"),
  "taxonomy-content-category": dynamic(
    () => import("../../../views/taxonomy-content-category.tsx"),
    "views/taxonomy-content-category.tsx",
  ),
  "template-about": dynamic(() => import("../../../views/template-about.tsx"), "views/template-about.tsx"),
  "template-contact": dynamic(() => import("../../../views/template-contact.tsx"), "views/template-contact.tsx"),
  "template-home": dynamic(() => import("../../../views/template-home.tsx"), "views/template-home.tsx"),
  "template-knowledge-hub": dynamic(
    () => import("../../../views/template-knowledge-hub.tsx"),
    "views/template-knowledge-hub.tsx",
  ),
  "template-process": dynamic(() => import("../../../views/template-process.tsx"), "views/template-process.tsx"),
  "template-search": dynamic(() => import("../../../views/template-search.tsx"), "views/template-search.tsx"),
  "template-testimonials": dynamic(
    () => import("../../../views/template-testimonials.tsx"),
    "views/template-testimonials.tsx",
  ),
  "template-work": dynamic(() => import("../../../views/template-work.tsx"), "views/template-work.tsx"),
};

viewManifestReader.set(manifest);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
